import React from 'react';
import { Navigate } from 'react-router-dom';

const Products = () => {
  return <Navigate to="/products/task" replace />;
};

export default Products;
